import type { ReactNode } from 'react';
import { Icons } from './icons';

export interface CalloutProps {
    /** Default `warning`. */
    tone?: 'warning' | 'danger' | 'info' | 'success';
    title?: ReactNode;
    children?: ReactNode;
    className?: string;
}

const ICON = { warning: Icons.warning, danger: Icons.danger, info: Icons.info, success: Icons.check };

/** DS gap: the library has no inline callout (toasts are transient); a tone icon, a bold title and text, on tokens. */
export function Callout(props: CalloutProps) {
    const tone = props.tone ?? 'warning';
    const Icon = ICON[tone];
    return (
        <div className={['ark-callout', `ark-callout--${tone}`, props.className].filter(Boolean).join(' ')} role={tone === 'danger' ? 'alert' : 'note'}>
            <span className="ark-callout-icon"><Icon size={18} /></span>
            <div className="ark-callout-content">
                {props.title ? <p className="ark-callout-title">{props.title}</p> : null}
                {props.children ? <div className="ark-callout-text">{props.children}</div> : null}
            </div>
        </div>
    );
}
